import React, {useEffect, useState} from "react";
import VirtualizedAutoCompleteInput from "../sharedFormComponents/VirtualizedAutoCompleteInput";
import {useOption} from "../../../hooks";
import _ from "lodash";

const SingleAutoComplete = ({options, selectedId, label, field, required, handleOnChange, handleOnError, defaultOption=null, error: externalError, helperText, ...autoCompleteProps}) => {
    const [isOpen, setIsOpen] = useState(false);

    const selectedOption = () => {
        return _.find(options, {id: selectedId}) || defaultOption;
    }
    const {...permissionOption} = useOption(required, selectedOption());

    useEffect(() => {
        permissionOption.setOption(selectedOption());
    }, [options, selectedId]);

    useEffect(() => {
        handleOnError(permissionOption.error);
    }, [permissionOption.value]);

    const onChangeAutocomplete = (field, value) => {
            permissionOption.setOption(value);
            handleOnChange(value);
    }

    const onInputChangeAutocomplete = (event, value) => {
        // if (_.isEmpty(event.target.value)) {
        //     permissionOption.reset();
        // }
    }

    return (
        <VirtualizedAutoCompleteInput
            open={isOpen}
            handleOpen={(open) => setIsOpen(open)}
            selectedValues={permissionOption.value}
            handleOnChangeAutocomplete={onChangeAutocomplete}
            handleInputChangeAutocomplete={onInputChangeAutocomplete}
            value={selectedOption()}
            label={label}
            field={field}
            options={options}
            required={required}
            error={externalError || permissionOption.error}
            helperText={helperText}
            {...autoCompleteProps}
        />
    )
}

export default SingleAutoComplete;